var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topbar',{attrs:{"titulo":_vm.$t('ACADEMICO.BOLETIM_NOTAS_PARCIAIS'),"subtitulo":_vm.$t('ACADEMICO.DESCRICAO_BOLETIM'),"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }